// extracted by mini-css-extract-plugin
export default {"addButton":"DIDNumbersRowDescription_addButton__w0Ikw","description":"DIDNumbersRowDescription_description__zgGFG","form":"DIDNumbersRowDescription_form__-alDs"};